import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import { NewCheckoutPage } from './LazyModules/LazyModules';
import OrderConfirmationPage from './containers/Pages/OrderConfirmation/OrderConfirmationPageLazy';
import ReviewPage from './containers/Pages/Review/ReviewPageLazy';
// eslint-disable-next-line import/no-named-as-default
import AccountLockedPage from './containers/Pages/AccountLocked/AccountLockedPage';

export default function App() {
    return (
        <Switch>
            <Route exact path="/checkout" component={NewCheckoutPage} />
            <Route
                exact
                path="/checkout/bopis"
                // eslint-disable-next-line react/jsx-props-no-spreading
                render={(props) => <NewCheckoutPage renderFrom="bopis" {...props} />}
            />
            <Route
                exact
                path="/checkout/shipping"
                // eslint-disable-next-line react/jsx-props-no-spreading
                render={(props) => <NewCheckoutPage renderFrom="shipping" {...props} />}
            />
            <Route
                exact
                path="/checkout/payment"
                // eslint-disable-next-line react/jsx-props-no-spreading
                render={(props) => <NewCheckoutPage renderFrom="payment" {...props} />}
            />
            <Route exact path="/checkout/oc" component={OrderConfirmationPage} />
            <Route exact path="/checkout/review" component={ReviewPage} />
            <Route exact path="/checkout/account-locked" component={AccountLockedPage} />
            {/* when none of the above match, <NoMatch> will be rendered  */}
            <Route component={NotFound} />
        </Switch>
    );
}

// this import is to move the common css to the root
// instead of going into lazy loaded css
App.Layout = Layout;
